import { select } from "d3";
export class HoverElement {
  constructor({ svg, svgAux = null, name }) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
    this.d3 = null;
    this.className = "";
    this.name = name;
  }

  create() {
    // To Be implemented
  }

  recalculate() {
    // To Be implemented
  }

  show() {
    select("." + this.className).style("opacity", 1);
  }

  hide() {
    select("." + this.className).style("opacity", 0);
  }
}
